// LEADERSHiP+ : the shelf, the Roundtable check-in, and meeting requests.

export const LEADERSHIP = {
  // A link id, not an address — see netlify/lib/links.mts.
  driveFolder:"lead-drive-folder",
  files:[
    {
      emoji:"🧠",
      title:"Leadership Lid — Session Notes",
      tone:"ink",
      id:"lead-leadership-lid-session-notes"
    },
    {
      emoji:"🧬",
      title:"Culture Codes: Leader Deep Dive",
      tone:"yellow",
      id:"lead-culture-codes-leader-deep-dive"
    },
    {
      emoji:"🗺️",
      title:"Run the Room — Sunday Playbook",
      tone:"paper",
      id:"lead-run-the-room-sunday-playbook"
    },
    {
      emoji:"🌱",
      title:"Multiplying Leaders",
      tone:"paper",
      id:"lead-multiplying-leaders"
    },
    {
      emoji:"📊",
      title:"Working Genius Team Map",
      tone:"yellow",
      id:"lead-working-genius-team-map"
    },
    {
      emoji:"🧭",
      title:"90-Day Leader Plan",
      tone:"ink",
      id:"lead-90-day-leader-plan"
    }
  ]
};

export const CHECKIN_MOODS = [
  {
    k:"fire",
    label:"🔥 Fired up",
    reply:"Come on. Pour that into somebody today — fire spreads."
  },
  {
    k:"steady",
    label:"🙂 Steady",
    reply:"Steady is underrated. Faithful beats flashy every single week."
  },
  {
    k:"stretched",
    label:"😮‍💨 Stretched",
    reply:"Heard. Stretched is where growth lives — but you don't carry it alone.",
    offer:true
  },
  {
    k:"empty",
    label:"🪫 Running on empty",
    reply:"Thank you for being honest. Leaders refill too — let somebody pour into you this week.",
    offer:true
  }
];

// Planning Center person ids so a request can be routed to one inbox rather
// than shown to everyone at director level. `pid: null` means "no named
// recipient" — those route to the pastoral tier, same as a private prayer note.
export const MEET_WITH = [
  { label: "Pastor Courtney", pid: "92987210" },
  { label: "Pastor Quinetta", pid: "92987541" },
  { label: "Pastor Trestan", pid: "92987135" },
  { label: "My Director", pid: null },
];

export const MEET_DURATIONS = [
  {
    v:"15 min",
    note:"quick huddle"
  },
  {
    v:"30 min",
    note:"real conversation"
  },
  {
    v:"45 min",
    note:"deep dive"
  },
  {
    v:"60 min",
    note:"heavy season — take the time you need"
  }
];

export const MEET_FORMATS = [
  "💻 Online",
  "🤝 In person"
];
